import { useEffect } from 'react';
import { useShellStore } from './shell-store';

/**
 * ⌘K / Ctrl+K 打开命令面板。
 *
 * 页面自己占用同一个键时外壳让路：页面在**捕获阶段**监听并 preventDefault
 * （标的库 VaultBoard 的 ⌘K 就是这样），外壳在冒泡阶段看到 defaultPrevented 即跳过。
 * 不能靠注册顺序 —— 外壳先挂载，页面后挂载，冒泡阶段外壳永远先触发。
 */
export function useShellHotkeys() {
  const setPaletteOpen = useShellStore((s) => s.setPaletteOpen);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.defaultPrevented) return;
      if ((e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen(!useShellStore.getState().paletteOpen);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setPaletteOpen]);
}
